<template>
	<div>
		<v-btn
			v-az-auth="permissoes.gerarRelatorio"
			outlined
			small
			id="btnGerarPdf"
			color="grey"
			text
			class="my-2"
			@click="baixarRelatorio"
			>Gerar PDF</v-btn
		>
	</div>
</template>
<script>
import { actionTypes } from '@/core/constants'

export default {
	name: 'botao-gerar-pdf-historico',
	props: {
		tipoHistorico: {
			type: String,
			required: true,
		},
		idEntidade: {
			type: Number,
			required: true,
		},
	},
	methods: {
		async baixarRelatorio() {
			await this.$store.dispatch(actionTypes.GERAR_RELATORIO.BAIXAR_RELATORIO, {
				tipoHistorico: this.tipoHistorico,
				entidadeId: this.idEntidade,
			})
		},
	},
}
</script>
